import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {  LeavesStatusVM, LeavesTypesVM,NewLeaveInfo,  } from '../entities/global/model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Tuple } from '../setup-equipment/setup-equipment.model';


@Injectable()
export class SafetyLeavesService {

  constructor(private _http: Http) {

  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  
  public GetAllLeavesStatus(): Observable<LeavesStatusVM[]> {
    return this._http.get('api/LeaveManagment/GetAllLeavesStatus').share().map(
      (response: Response) => <LeavesStatusVM[]>response.json()).catch(this.handleError);
  }

  public GETAllLeavesTypes(): Observable<LeavesTypesVM[]> {
    return this._http.get('api/LeaveManagment/GETAllLeavesTypes').share().map(
      (response: Response) => <LeavesTypesVM[]>response.json()).catch(this.handleError);
  }

  public CreateNewLeaveRequest(params: NewLeaveInfo): Observable<boolean> {

    console.log("params", params)
    return this._http.post("api/LeaveManagment/CreateNewLeaveRequest", params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public LoadLeaveAttacheDoc(params: NewLeaveInfo): Observable<NewLeaveInfo> {
    return this._http.post("api/LeaveManagment/LoadLeaveAttacheDoc", params).share().map(
      (response: Response) => <NewLeaveInfo>response.json()).catch(this.handleError);
  }

  public GETAllLeaveRequests(params: NewLeaveInfo): Observable<NewLeaveInfo[]> {
    return this._http.post("api/LeaveManagment/GETAllTheLeavesForLoggedUser", params).share().map(
      (response: Response) => <NewLeaveInfo[]>response.json()).catch(this.handleError);
  }
  
  public UpdateLeaveStatus(params: NewLeaveInfo): Observable<boolean> {
    return this._http.post("api/LeaveManagment/UpdateLeaveStatus", params).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GETAllLeaves(params: NewLeaveInfo): Observable<NewLeaveInfo[]> {
    return this._http.post("api/LeaveManagment/GETAllLeaves", params).share().map(
      (response: Response) => <NewLeaveInfo[]>response.json()).catch(this.handleError);
  }
}
